import { render } from "./areaManagement.vue?vue&type=template&id=2cdceffc&scoped=true"
import script from "./areaManagement.vue?vue&type=script&lang=js"
export * from "./areaManagement.vue?vue&type=script&lang=js"

import "./areaManagement.vue?vue&type=style&index=0&id=2cdceffc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cdceffc"]])

export default __exports__